import React from 'react';
import './FullImageStyle.css';

const FullImageSection = ({ desktopImage, mobileImage, altText = "Full Image" }) => {
  return (
    <section className="full-image-section">
      <picture>
        {/* Mobile version */}
        <source srcSet={mobileImage} media="(max-width: 768px)" />
        {/* Desktop version */}
        <source srcSet={desktopImage} media="(min-width: 769px)" />
        
        {/* Fallback (desktop by default) */}
        <img src={desktopImage} alt={altText} className="full-image" />
      </picture>
    </section>
  );
};

export default FullImageSection;
